import { render, staticRenderFns } from "./SwiftForm.vue?vue&type=template&id=24127ada"
import script from "./SwiftForm.vue?vue&type=script&lang=js"
export * from "./SwiftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports